const MAINTENANCE_STATE_URL = process.env.REACT_APP_OPERATIONS_PUBLIC_MAINTENANCE_URL || '/ops-public/maintenance';
const MAINTENANCE_MAGAZINE_URL = process.env.REACT_APP_OPERATIONS_PUBLIC_MAGAZINE_URL || '/ops-public/maintenance-magazine';
const OPERATIONS_PROFILE = String(
  process.env.REACT_APP_OPERATIONS_PROFILE
  || (process.env.NODE_ENV === 'production' ? 'PRODUCTION' : 'LOCAL')
).trim().toUpperCase() === 'LOCAL' ? 'LOCAL' : 'PRODUCTION';
const STORAGE_KEY = `npc:maintenance:page-state:v1:${OPERATIONS_PROFILE}`;
const MAGAZINE_STORAGE_KEY = `npc:maintenance:magazine:v1:${OPERATIONS_PROFILE}`;

function safeJsonParse(value, fallback = null) {
  try { return JSON.parse(value); } catch (_) { return fallback; }
}

export function readMaintenancePageCache() {
  if (typeof window === 'undefined') return null;
  try { return safeJsonParse(window.localStorage.getItem(STORAGE_KEY), null); } catch (_) { return null; }
}

export function writeMaintenancePageCache(value) {
  if (typeof window === 'undefined') return;
  try {
    if (!value) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (_) {}
}

export function readMaintenanceMagazineCache() {
  if (typeof window === 'undefined') return null;
  try { return safeJsonParse(window.localStorage.getItem(MAGAZINE_STORAGE_KEY), null); } catch (_) { return null; }
}

export function writeMaintenanceMagazineCache(value) {
  if (typeof window === 'undefined') return;
  try {
    if (!value) window.localStorage.removeItem(MAGAZINE_STORAGE_KEY);
    else window.localStorage.setItem(MAGAZINE_STORAGE_KEY, JSON.stringify(value));
  } catch (_) {}
}


function withOperationsProfile(url) {
  const raw = String(url || '');
  if (/[?&]profile=/i.test(raw)) return raw;
  const separator = raw.includes('?') ? '&' : '?';
  return `${raw}${separator}profile=${encodeURIComponent(OPERATIONS_PROFILE)}`;
}

async function fetchJson(url) {
  const response = await fetch(url, {
    method: 'GET',
    cache: 'no-store',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`maintenance public api ${response.status}`);
  return response.json();
}

export async function fetchMaintenancePublicState() {
  return fetchJson(withOperationsProfile(MAINTENANCE_STATE_URL));
}

export async function fetchMaintenanceMagazine() {
  return fetchJson(withOperationsProfile(MAINTENANCE_MAGAZINE_URL));
}
